module.exports = __webpack_public_path__ + "b7d16cf53f3d5bde0b5483916c188f9a.png";